import React, { useContext, useEffect, useState } from 'react';
import { Context as Auth } from '../../../services/auth/AuthContext';
import { Button, Table } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import Spinner from '../../../components/navigation/Spinner';
import '../../../components/layout/layout.css';
import { getStrengthByQuery } from '../../../services/strength.service';
import { getAccountById } from '../../../services/user.service';
import { useTranslation } from 'react-i18next';
import { capitalize } from '../../../utils/utils';

const UserStrength = (props) => {
  const { user } = useContext(Auth);
  const params = useParams();
  const navigate = useNavigate();
  const [strengths, setStrengths] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (user.account) {
      loadStrengths(user.account._id);
    }
  }, [user.account]);

  const loadStrengths = async (userId) => {
    const { status, data } = await getStrengthByQuery({ account: userId, isActive: true }, user.token);
    if (status === 200) {
      const strengthsArr = [];
      for await (const strength of data.data) {
        strength.key = strength._id;
        strengthsArr.push(strength);
      }
      setStrengths(strengthsArr);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: capitalize(t('strengthTest')),
      // dataIndex: ['name', 'surname', 'email', 'phone'],
      key: 'all',
      // eslint-disable-next-line react/display-name
      render: (record) => (
        <React.Fragment>
          {record.name}
          <br />
          {record.description}
        </React.Fragment>
      ),
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 5
      },
      responsive: ['xs']
    },
    {
      title: capitalize(t('name')),
      key: 'name',
      render: (record) => (
        <React.Fragment>
          {record.name}
        </React.Fragment>
      ),
      responsive: ['sm']
    },
    {
      title: capitalize(t('description')),
      key: 'description',
      // eslint-disable-next-line react/display-name
      render: (record) => record.description,
      responsive: ['sm']
    }
  ];

  function onChange (pagination, filters, sorter, extra) {

  }

  if (loading) {
    return (
      <Spinner/>
    );
  } else {
    return (
      <>
        <Table columns={columns} dataSource={strengths} onChange={onChange} onRow={(record, rowIndex) => {
          return {
            onClick: event => { navigate('/user/strength/' + record._id); }, // click row
            onDoubleClick: event => {}, // double click row
            onContextMenu: event => {}, // right button click row
            onMouseEnter: event => {}, // mouse enter row
            onMouseLeave: event => {} // mouse leave row
          };
        }} rowClassName={'row-pointer'}
        />
        <br />
      </>
    );
  };
};

export default UserStrength;
